import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const BreadcrumbContext = createContext(null);

export function BreadcrumbProvider({ children }) {
  const [segmentLabels, setSegmentLabels] = useState({});

  const setLabel = useCallback((pathname, label) => {
    if (!pathname || !label) return;
    setSegmentLabels((prev) => ({ ...prev, [pathname]: label }));
  }, []);

  const clearLabel = useCallback((pathname) => {
    if (!pathname) return;
    setSegmentLabels((prev) => {
      if (!(pathname in prev)) return prev;
      const next = { ...prev };
      delete next[pathname];
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({ segmentLabels, setLabel, clearLabel }),
    [segmentLabels, setLabel, clearLabel],
  );

  return (
    <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb() {
  const ctx = useContext(BreadcrumbContext);
  if (!ctx) {
    return { segmentLabels: {}, setLabel: () => {}, clearLabel: () => {} };
  }
  return ctx;
}
